<template>
    <table>
        <tbody>
            <tr v-for="(gamificationItem, index) in gamification_items.data" :key="gamificationItem.id">
                <td>
                    <img :src="gamificationItem.image_path" alt="" class="h-6" />
                </td>
                <td>
                    <div>
                        <span>{{ gamificationItem.name }}</span>
                        <span v-if="gamificationItem.level_required"> ({{ gamificationItem.level_required }})</span>
                    </div>
                    <div>
                        {{ gamificationItem.description }}
                    </div>
                    <div v-if="gamificationItem.characterTypes.length > 0">
                        <div v-for="characterType in gamificationItem.characterTypes" :key="characterType.id">
                            {{ characterType.name }}
                        </div>
                    </div>
                </td>
                <td>
                    <BadgePill color="yellow" v-if="gamificationItem.price">
                        {{ gamificationItem.price }}
                    </BadgePill>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import LayoutBlank from '@/Shared/LayoutBlank.vue';
import BadgePill from '@/components/BadgePill.vue';

export default {
    components: {
        BadgePill,
    },
    layout: LayoutBlank,
    name: 'Index',
    props: ['meta', 'gamification_items', 'filters', 'options', 'gamificationSet'],
    data() {
        return {
            form: this.$inertia.form({
                search: this.filters.search,
                type: this.filters.type,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
